import { Instagram, MessageCircle, MapPin, Phone } from "lucide-react";
import { SITE, WHATSAPP_URL, MAPS_URL } from "@/constants/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-noise opacity-[0.03]" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-1 bg-gradient-to-r from-transparent via-red-600 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <img
              src={SITE.logo}
              alt="Full Force Car Premium"
              width="200"
              height="80"
              loading="lazy"
              decoding="async"
              className="h-16 w-auto object-contain mb-5"
              style={{
                filter:
                  "invert(1) hue-rotate(180deg) drop-shadow(0 0 12px rgba(229,57,53,0.25))",
              }}
            />
            <p className="text-zinc-400 text-sm leading-relaxed max-w-md">
              Câmbio Automático e Mecânica em Geral — uma oficina premium em Jundiaí/SP comprometida com diagnóstico preciso, transparência e qualidade técnica.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-11 h-11 flex items-center justify-center border border-zinc-800 hover:border-red-600 hover:bg-red-600/10 transition-all duration-300 text-zinc-400 hover:text-red-500"
                aria-label="Instagram"
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="w-11 h-11 flex items-center justify-center border border-zinc-800 hover:border-red-600 hover:bg-red-600/10 transition-all duration-300 text-zinc-400 hover:text-red-500"
                aria-label="WhatsApp"
              >
                <MessageCircle size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white font-bold mb-5">Navegação</p>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li><a href="#inicio" className="hover:text-red-500 transition-colors">Início</a></li>
              <li><a href="#sobre" className="hover:text-red-500 transition-colors">Sobre</a></li>
              <li><a href="#servicos" className="hover:text-red-500 transition-colors">Serviços</a></li>
              <li><a href="#galeria" className="hover:text-red-500 transition-colors">Galeria</a></li>
              <li><a href="#diferenciais" className="hover:text-red-500 transition-colors">Diferenciais</a></li>
              <li><a href="#avaliacoes" className="hover:text-red-500 transition-colors">Avaliações</a></li>
              <li><a href="#localizacao" className="hover:text-red-500 transition-colors">Localização</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-white font-bold mb-5">Contato</p>
            <ul className="space-y-4 text-sm text-zinc-400">
              <li className="flex items-start gap-3">
                <MapPin size={16} strokeWidth={1.5} className="text-red-500 flex-shrink-0 mt-0.5" />
                <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  {SITE.address}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} strokeWidth={1.5} className="text-red-500 flex-shrink-0 mt-0.5" />
                <a href={`tel:+${SITE.phoneRaw}`} className="hover:text-white transition-colors">{SITE.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Instagram size={16} strokeWidth={1.5} className="text-red-500 flex-shrink-0 mt-0.5" />
                <a href={SITE.instagramUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">{SITE.instagram}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Full Force Car Premium. Todos os direitos reservados.
          </p>
          <p className="text-xs text-zinc-600 uppercase tracking-widest">
            Câmbio Automático · Mecânica · Jundiaí/SP
          </p>
        </div>
      </div>
    </footer>
  );
}
